// Egen Enum for API Request Params, da fagområde, målgruppe og verktøytype
// har entall for API requesten, mens flertall i URL Query Params
export enum APIRequestParamNames {
  Fagomrader = 'Fagomrader',
  Malgrupper = 'Malgrupper',
  VerktoyTyper = 'VerktoyTyper',
  Sortering = 'Sortering',
  Sorterstigende = 'SorterStigende',
  Sok = 'Sok',
  KreverForskrivning = 'KreverForskrivning',
  StotterAnonymOppstart = 'StotterAnonymOppstart',
}
